export default __webpack_public_path__ + "static/media/1762.e9e18984.png";